import { memo } from "react";
import { Box, Typography, Stack } from "@mui/material";

const InfoRow = ({ label, children, mb = 2 }) => (
  <Stack
    direction="row"
    alignItems="center"
    spacing={2}
    sx={{ mb, minHeight: "40px" }}
  >
    <Typography
      variant="body1"
      sx={{ fontWeight: "bold", width: "120px", flexShrink: 0 }}
    >
      {label}:
    </Typography>
    <Box
      sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1 }}
    >
      {children}
    </Box>
  </Stack>
);

export default memo(InfoRow);
